import { Component, NgModule } from '@angular/core';
import { AppInfoService, LanguageService } from '../../services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  constructor(public appInfo: AppInfoService, public languageService: LanguageService) {}
}

@NgModule({
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
